// extracted by mini-css-extract-plugin
module.exports = {"container":"az_ZQc","seeMoreReviews":"az__Qc","link":"az_aRc"};